import { render, staticRenderFns } from "./transferRecords.vue?vue&type=template&id=7a1cdbde&scoped=true&"
import script from "./transferRecords.vue?vue&type=script&lang=js&"
export * from "./transferRecords.vue?vue&type=script&lang=js&"
import style0 from "./transferRecords.vue?vue&type=style&index=0&id=7a1cdbde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1cdbde",
  null
  
)

export default component.exports